import React from "react";
import Hero from "../../components/medical/Hero";
import HighlightedContactSection from "../../components/HighlightedContactSection";

const PARAGRAPH_CLASS =
  "mt-3 text-sm leading-relaxed text-gray-700 md:text-base";

const SECTIONS = [
  {
    leftLabel: "UNSERE VERANTWORTUNG",
    heading: "Soziale Verantwortung in und für unsere Gesellschaft.",
    paragraphs: [
      "Als eine lange am Markt tätige medizinische Beratungsgesellschaft sehen wir es als unsere gesellschaftliche Verpflichtung an, soziale Verantwortung in und für unsere Gesellschaft zu übernehmen. In jeder Gesellschaft gibt es Stärkere und Schwächere. Unsere Auffassung sozialer Gerechtigkeit besteht im Prinzip des Gebens und Nehmens.",
      "Als verantwortungsvolles Unternehmen wollen wir konkrete Beiträge zur Lösung gesellschaftlicher Probleme leisten.",
      "Für die betroffenen Menschen vor Ort soll sich durch greifbare Maßnahmen und Unterstützung etwas zum Besseren verändern. Daher gehen wir ergebnisorientiert vor und bevorzugen langfristig angelegte Projekte.",
      "Mit der finanziellen Ermöglichung und Umsetzung der sozialen Projektarbeit kommen wir unserer gesellschaftlichen Verantwortung gerne nach. Und mehr noch – es ist uns eine Herzensangelegenheit anderen Menschen – gerade den Menschen die dringend Hilfe benötigen – Chancen zu eröffnen und Wege in die Zukunft zu ebnen, damit sie wirklich gleichberechtigt an der Gesellschaft teilnehmen können.",
    ],
  },
  {
    leftLabel: "FÜR UNSERE KUNDEN",
    heading: "Für unsere Kunden",
    paragraphs: [
      "Beratungsleistung bekommen, mit einem zusätzlichen gutem Gefühl! Denn Sie wissen: REPEXO verdient natürlich an jeder Beauftragung von Ihnen als Mandant. Aber: Jeweils 1 % der Erträge werden an unser jeweiliges Projekt, welches wir gerade unterstützen, überwiesen. So bewirken Sie als Mandant ebenfalls viel Gutes für Menschen in Not. Ganz einfach, quasi nebenbei und ohne einen Cent extra zu bezahlen.",
      <>Informationen über unser langfristiges Projekt, welches wir gerade aktuell unterstützen, finden Sie hier:{" "}
        <a
          href="https://www.mein-blindenfuehrhund.de"
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium text-gray-900 underline underline-offset-2 hover:text-gray-700"
        >
          www.mein-blindenfuehrhund.de
        </a>
      </>,
    ],
  },
];

export default function SocialResponsibilityPage() {
  return (
    <>
      <Hero
        title="Soziale Verantwortung"
        subheading="Gesellschaftliche Verantwortung leben – konkret und ergebnisorientiert."
      />
      <section className="bg-white pt-0 pb-16 md:pb-24">
        {SECTIONS.map((section, i) => (
          <div
            key={i}
            className="border-b border-gray-100 py-12 md:py-16 first:pt-8"
          >
            <div className="container-app mx-auto flex flex-col gap-8 px-4 md:flex-row md:gap-12 lg:gap-16">
              {section.leftLabel && (
                <div className="flex-shrink-0 md:w-36 lg:w-40">
                  <span className="detail-side-label text-xs font-semibold uppercase tracking-[0.2em] text-gray-700">
                    {section.leftLabel}
                  </span>
                </div>
              )}
              <div className="min-w-0 flex-1 max-w-4xl">
                <h2 className="text-2xl font-semibold leading-snug text-gray-900 md:text-3xl">
                  {section.heading}
                </h2>
                {section.paragraphs?.map((p, j) => (
                  <p key={j} className={PARAGRAPH_CLASS}>
                    {p}
                  </p>
                ))}
              </div>
            </div>
          </div>
        ))}
        <HighlightedContactSection
          heading="Soziales Engagement besprechen"
          description="Sie möchten mehr über unsere Projekte erfahren oder mit uns zusammenarbeiten? Wir freuen uns auf Ihre Nachricht."
          buttonText="Jetzt Kontakt aufnehmen"
          sectionId="section-soziale-verantwortung-contact"
        />
      </section>
    </>
  );
}
